// extracted by mini-css-extract-plugin
export var articleContents = "BlogPost-module--articleContents--e2de1";
export var backLink = "BlogPost-module--backLink--4abd6";
export var backLinkContainer = "BlogPost-module--backLinkContainer--b53b6";
export var button = "BlogPost-module--button--c858e";
export var center = "BlogPost-module--center--892c7";
export var container = "BlogPost-module--container--b1e82";
export var decor = "BlogPost-module--decor--017e1";
export var left = "BlogPost-module--left--52c22";
export var lineAbove = "BlogPost-module--lineAbove--763ce";
export var newsAuthorBlock = "BlogPost-module--newsAuthorBlock--65b9d";
export var newsFeatureMedia = "BlogPost-module--newsFeatureMedia--3e332";
export var newsHeader = "BlogPost-module--newsHeader--2ae8c";
export var quote = "BlogPost-module--quote--1bb93";
export var relativeWrapper = "BlogPost-module--relativeWrapper--583db";
export var right = "BlogPost-module--right--28e8a";
export var wide = "BlogPost-module--wide--a00bf";